var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { useEffect, useState } from "react";
function determinePathAccessLevel(currentPathAuthorizationLevel, sessionAuthorizationLevel) {
    var isPartialPath = currentPathAuthorizationLevel === "partial";
    var isFullPath = currentPathAuthorizationLevel === "full";
    var isSessionPartialOrFull = sessionAuthorizationLevel === "partial" ||
        sessionAuthorizationLevel === "full";
    if (isPartialPath && !isSessionPartialOrFull) {
        return "restricted";
    }
    if (isFullPath && sessionAuthorizationLevel !== "full") {
        return "restricted";
    }
    return "unrestricted";
}
export function useGating(_a) {
    var _b = _a === void 0 ? {} : _a, pathsAuthorizationLevel = _b.pathsAuthorizationLevel, sessionAuthorizationLevel = _b.sessionAuthorizationLevel, onAccessRestricted = _b.onAccessRestricted, isSessionProcessing = _b.isSessionProcessing;
    var _c = __read(useState("pending"), 2), accessLevel = _c[0], setAccessLevel = _c[1];
    useEffect(function () {
        if (isSessionProcessing) {
            return;
        }
        if (!pathsAuthorizationLevel ||
            !Object.keys(pathsAuthorizationLevel).length) {
            setAccessLevel("undetermined");
            return;
        }
        if (sessionAuthorizationLevel !== "pending") {
            var currentPathAuthorizationLevel = Object.keys(pathsAuthorizationLevel).find(function (path) { return window.location.pathname.includes(path); });
            var level = currentPathAuthorizationLevel
                ? pathsAuthorizationLevel[currentPathAuthorizationLevel]
                : "";
            var accessRestrictionStatus = determinePathAccessLevel(level, sessionAuthorizationLevel);
            setAccessLevel(accessRestrictionStatus);
            if (accessRestrictionStatus === "restricted") {
                window.dispatchEvent(new CustomEvent("accessRestricted"));
                if (typeof onAccessRestricted === "function") {
                    onAccessRestricted();
                }
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        sessionAuthorizationLevel,
        pathsAuthorizationLevel,
        accessLevel,
        isSessionProcessing
    ]);
    return { accessLevel: accessLevel };
}
export default useGating;
